import Translate from './Translate'
export default Translate